import React from "react";
import { PersonalLoan, BusinessLoan, ProfessionalLoanicon } from "../../../assets/images";

const coveredBlocks = [
  {
    img: BusinessLoan,
    title: "Business Loan",
    desc: "Unlock your business's potential with our flexible business loans, offering competitive rates and fast approval to fuel your growth and success.",
    extraClass: "",
  },
  {
    img: PersonalLoan,
    title: "Personal Loan",
    desc: "Achieve your personal goals with our hassle-free personal loans, featuring quick approval, competitive rates, and flexible terms tailored to your needs.",
    extraClass: "green-boxes",
  },
  {
    img: ProfessionalLoanicon,
    title: "Professional Loan",
    desc: "Perfect for growing your practice or business. Use funds for new equipment, hiring staff, or relocating. Simplified process, quick approval!!",
    extraClass: "",
  },
];

const CoveredSection = ({ refProp }) => (
  <section className="covered-section" ref={refProp}>
    <div className="custom-gray"></div>
    <div className="inner-sec">
      <div className="covered-head">
        <h2 className="green-border">
          Get access to flexible loans for personal, business, and emergency needs, all at competitive rates.
          <div className="border-line"></div>
        </h2>
        <p>
          We will match you with a loan program that meets your financial needs. Our goal is to provide short-term liquidity, making funds available within 24 hours of application.
        </p>
      </div>
      <div className="container">
        <div className="row right-animation equal-height">
          {coveredBlocks.map((block, index) => (
            <div className="col-md-4" key={index}>
              <div className={`covered_blocks ${block.extraClass}`}>
                <img src={block.img} className="imgcoverIcons" alt={block.title} />
                <h3>{block.title}</h3>
                <p>{block.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="custom-gray bottom"></div>
  </section>
);

export default CoveredSection;
